import {createSelector} from 'reselect';

const featuresSelector = ({gsConfig = {}} = {}) => gsConfig?.features || {};
const showBrokerInfoSelector = createSelector(
  featuresSelector,
  (features) => features && !!features['event.brokerInfo.show']
);

const showBrokerInfoDSASelector = createSelector(
  featuresSelector,
  (features) => features && !!features['event.brokerInfo.dsa.show']
);

const eventSelector = (state) => state?.event || {};
const listingsSelector = (state) => state?.listings || {};
const venueConfigSelector = createSelector(eventSelector, ({venueConfig}) => venueConfig || {});
const sectionZoneMetasSelector = createSelector(venueConfigSelector, ({sectionZoneMetas}) => sectionZoneMetas || {});

const eventDataSelector = createSelector(eventSelector, (event) => {
  const {venue, venueConfig, isGA, showTicketRecoInd, loading} = event;
  const {id: venueId} = venue || {};
  const {id: venueConfigId, map} = venueConfig || {};
  const {viewFromSection} = map || {};

  return {
    venueId,
    venueConfigId,
    viewFromSection,
    isGA,
    showTicketRecoInd,
    isEventInfoLoading: loading,
  };
});

const listingsDataSelector = createSelector(listingsSelector, ({data, quantity, hasMore, listingLoading, page}) => {
  return {
    listings: data || [],
    quantity,
    hasMore,
    listingLoading: listingLoading || false,
    page: page || 0,
  };
});

const zoneColorsSelector = createSelector(sectionZoneMetasSelector, (sectionZoneMetas) => {
  return Object.keys(sectionZoneMetas).reduce((lookup, sectionId) => {
    const section = sectionZoneMetas[sectionId] || {};
    const {c: color, zi: zoneId} = section;
    if (zoneId) {
      return {
        [zoneId]: color || null,
        ...lookup,
      };
    }

    return lookup;
  }, {});
});

export {showBrokerInfoSelector, showBrokerInfoDSASelector, eventDataSelector, listingsDataSelector, zoneColorsSelector};
